import { Injectable } from '@angular/core';
import { AuthenticationService, CoreService } from '@charlesschwab/sac-ui-core';
import { FeatureToggleConfigurationProperties } from '@schwab/schwab-feature-toggle-angular';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  constructor(private readonly authService: AuthenticationService, private coreService: CoreService) {}

  initializeApp(): Promise<void> {
    return new Promise<void>((resolve) => {
      if (this.authService.externalAccessToken) {
        resolve();
        return;
      }

      this.authService.authenticate().subscribe(
        () => {
          resolve();
        },
        (error) => {
          console.log('Unable to authenticate to initialize the app', error);
        }
      );
    });
  }

  setClientSideId(): FeatureToggleConfigurationProperties {
    let launchDarklyClientSideId: string;

    switch(this.coreService.environment.toLowerCase()){
      //Dev
      case 'dev':
      case 'sit01':
        launchDarklyClientSideId = '66b606664531ff10ae3b64cf';
        break;
      //QA
      case 'tb':
      case 'ty':
      case 'pvs':
      case 'qa':
      case 'qae01':
        launchDarklyClientSideId = '67eff2117f87dc0c0a15b45b';
        break;
      //PROD
      case 'eis':
      case 'prod':
      case '':
        launchDarklyClientSideId = '66b606664531ff10ae3b64d0';
        break;
      default:
        launchDarklyClientSideId = '';
        console.log(`Feature flags failed to load.`)
        break;
    }

    const launchDarklyEnvConfig: FeatureToggleConfigurationProperties = {
      clientSideId: launchDarklyClientSideId
    }

    return launchDarklyEnvConfig;
  }
}
